// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gz438CXiQ5o3n7Gv2YTm{display:block}`, "",{"version":3,"sources":["webpack://./src/app/common/components/tag.component/style.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA","sourcesContent":[".app-tag {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-tag": `gz438CXiQ5o3n7Gv2YTm`
};
export default ___CSS_LOADER_EXPORT___;
